import React from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../VideoSettingsContext";
import Preview from "./Preview";
import ThumbnailOption from "./ThumbnailOption";

var ThumbnailPicker = function ThumbnailPicker(_ref) {
  var VideoSettingsContext = _ref.VideoSettingsContext,
      thumbnailQuality = _ref.thumbnailQuality,
      thumbnailMaxSize = _ref.thumbnailMaxSize;
  var selectFrame = VideoSettingsContext.selectFrame,
      state = VideoSettingsContext.state;
  var videoSrc = state.videoSrc,
      frames = state.frames,
      selectedFrame = state.selectedFrame,
      videoCaption = state.videoCaption,
      videoThumbnail = state.videoThumbnail,
      decoration = state.decoration;
  return React.createElement("div", {
    className: "recorder__form-right"
  }, React.createElement(Preview, {
    captionText: videoCaption,
    videoSrc: videoSrc,
    videoThumbnail: videoThumbnail,
    selectedFrame: selectedFrame,
    decoration: decoration,
    thumbnailQuality: thumbnailQuality,
    thumbnailMaxSize: thumbnailMaxSize
  }), React.createElement("div", {
    className: "form form--style-account"
  }, React.createElement("label", {
    className: "form__label"
  }, "video thumbnail", React.createElement("button", {
    className: "form__label-button",
    onClick: VideoSettingsContext.refreshThumbnailOptions
  }, "refresh")), React.createElement("div", {
    className: "form__container"
  }, React.createElement("div", {
    className: "recorder__thumbs"
  }, frames.map(function (frameTime) {
    return React.createElement(ThumbnailOption, {
      key: frameTime,
      videoSrc: videoSrc,
      time: frameTime,
      isSelected: frameTime === selectedFrame,
      onClick: selectFrame,
      thumbnailQuality: thumbnailQuality,
      thumbnailMaxSize: thumbnailMaxSize
    });
  })))));
};

ThumbnailPicker.propTypes = process.env.NODE_ENV !== "production" ? {
  VideoSettingsContext: PropTypes.object.isRequired,
  thumbnailQuality: PropTypes.number,
  thumbnailMaxSize: PropTypes.number
} : {};
export default consumeContext(ThumbnailPicker);